import { css, StyleSheet } from 'aphrodite'
import CloseIcon from '../svgs/CloseIcon'

const CloseButton = ({ clickHandler }) => {
	return (
		<button className={css(styles.btn)} onClick={clickHandler}>
			<CloseIcon />
		</button>
	)
}

export default CloseButton

const styles = StyleSheet.create({
	btn: {
		background: 'none',
		border: 0,
		outline: 0,
		':hover': {
			cursor: 'pointer',
		},
	},
})
